import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import './Privacy.css';

const Privacy = () => (
  <>
    <div className="page-header">
      <div className="container">
        <div className="section-label">Legal</div>
        <h1>Privacy Policy &amp; <em>Disclaimer</em></h1>
        <p>Your privacy and security are our top priorities.</p>
      </div>
    </div>

    <section className="section">
      <div className="container">
        <div className="privacy-grid">
          <div className="privacy-box">
            <h3>🔐 Privacy Policy</h3>
            <p>
              We respect your privacy and are committed to protecting your personal and financial information.
              All data shared with A-Mobile Tax Services is securely handled and used only for tax preparation
              purposes in compliance with IRS regulations.
            </p>
            <p>
              We do not sell, share, or disclose your information to any third parties without your explicit consent.
              All client data is stored securely and access is restricted to authorized personnel only.
            </p>
            <p>
              By using our services, you agree that we may collect the information necessary to prepare your tax returns
              and fulfill our legal obligations as a tax preparation service.
            </p>
          </div>

          <div className="privacy-box">
            <h3>⚠️ Disclaimer</h3>
            <p>
              A-Mobile Tax Services is not a law firm. Tax outcomes may vary based on individual circumstances.
              We comply with all IRS regulations and due diligence requirements.
            </p>
            <p>
              The information provided on this website is for general informational purposes only and does not
              constitute legal or financial advice. For legal matters, please consult a licensed attorney.
            </p>
            <p>
              Results may vary. Past refund amounts do not guarantee future results. All tax filings are based on
              information provided by the client. Clients are responsible for the accuracy of documents submitted.
            </p>
          </div>
        </div>

        <div className="privacy-contact-box">
          <h3>Questions about our Privacy Policy?</h3>
          <p>Contact us directly — we're happy to answer any questions about how we handle your data.</p>
          <div style={{ display: 'flex', gap: '14px', marginTop: '20px', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn btn-navy">📧 Contact Us</Link>
            <a href="tel:+12244154202" className="btn btn-outline-navy" style={{ borderColor: 'var(--navy)', color: 'var(--navy)' }}>
              📞 224-415-4202
            </a>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Privacy;
